
import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
    Card,
    CardBody,
    CardTitle,
    FormFeedback,   
    Input
} from "reactstrap";
 
import { handleLoadDashboards } from "../../actions/dashboards";
import DataLoading from "../../components/organisms/DataLoading";
import paths from "../../constants";
import IPbiDashboard from "../../models/IPbiDashboard";
import { IStore } from "../../models/IStore"; 
import FavoritesIcon from "../molecules/FavoritesIcon";
import NotFavoritesIcon from "../molecules/NotFavoritesIcon";
import IUserFavorite from "../../models/IUserFavorite";
import { handleAddFavorite, handleDeleteFavorite } from "../../actions/userFavorites";



export interface IListUserDashboardsPageProps {
    accessToken: string;
    onHandleLoadDashboards: (accessToken: string) => void;
    dashboards: IPbiDashboard[];
    dashboardsLoaded: boolean;
    userId: number;
    activeRoleId: number;
    userFavoritesDashboards: IUserFavorite[];
    onHandleAddFavorite: (accessToken: string, favorite: IUserFavorite) => void;
    onHandleDeleteFavorite: (accessToken: string, favoriteId: number) => void;
}

export interface IListUserDashboardsPageState {
    filteredDashboards: IPbiDashboard[];
    matchedNameExact: boolean;
    name: string;
    noMatchingNames: boolean;
    userFavorites: IUserFavorite[];
}

class ListUserDashboardsPage extends React.Component<
    IListUserDashboardsPageProps,
    IListUserDashboardsPageState
> {
    public isLoaded = false;
    public state = {
        filteredDashboards: [] as IPbiDashboard[],
        matchedNameExact: false,
        name: "",
        noMatchingNames: false,
        userFavorites: [] as IUserFavorite[]
    };

    constructor(props: IListUserDashboardsPageProps) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.toggleFavorite = this.toggleFavorite.bind(this);
        this.state.userFavorites = props.userFavoritesDashboards;
    }




    public handleInputChange(e: any): void {
        e.preventDefault();
        const { dashboards } = this.props;

        const searchDashboardDisplayName = e.target.value.toLowerCase();
        if (!searchDashboardDisplayName) {
            this.setState({
                filteredDashboards: dashboards
            });
        } else {
            const filteredDashboards: IPbiDashboard[] = dashboards.filter(
                (dashboard: IPbiDashboard) =>
                    dashboard.displayName
                        .toLowerCase()
                        .includes(searchDashboardDisplayName)
            );
            if (filteredDashboards.length === 1) {
                this.setState({ matchedNameExact: true, noMatchingNames: false });
            } else if (filteredDashboards.length === 0) {
                this.setState({ noMatchingNames: true, matchedNameExact: false });
            } else {
                this.setState({ matchedNameExact: false, noMatchingNames: false });
            }
            this.setState({
                filteredDashboards
            });
        }
    }



    public toggleFavorite = (dashboardId: number) => {
        const {
            accessToken,
            userId,
            activeRoleId,
            onHandleAddFavorite,
            onHandleDeleteFavorite
        } = this.props;


        if (this.state.userFavorites.find(fav => fav.reportId === dashboardId)) {

            const newUserFavorites: IUserFavorite[] = this.state.userFavorites.filter(fav => fav.reportId === dashboardId);
            onHandleDeleteFavorite(accessToken, newUserFavorites[0].id);


           // this.setState({ userFavorites: newUserFavorites  });

        
        }
        else {

          
            const newFav = {
                userProfileId: userId,
                roleId: activeRoleId,
                reportId: dashboardId,
                reportType: 'DASHBOARD',
                isEnabled: true
            } as IUserFavorite

            onHandleAddFavorite(accessToken, newFav);

            //this.setState({ userFavorites: newUserFavorites }, () => {
            //    console.log(this.state.userFavorites.length)
            //});

          
        };

        
         

    };
     


    public async componentDidMount() {
        const {
            accessToken,
            onHandleLoadDashboards,
            dashboards,
            dashboardsLoaded
        } = this.props;
        this.isLoaded = true;
        if (this.isLoaded) {
            if (!dashboardsLoaded) {
                onHandleLoadDashboards(accessToken);
            }
            this.setState({ filteredDashboards: dashboards });
        }
    }

    public componentDidUpdate(prevProps: IListUserDashboardsPageProps) {
        const { dashboards, userFavoritesDashboards } = this.props;

        if (prevProps.dashboards !== dashboards) {
            this.setState({
                filteredDashboards: dashboards
            });
        }

         if (prevProps.userFavoritesDashboards !== userFavoritesDashboards) {
            this.setState({
                userFavorites: userFavoritesDashboards 
            })
    }
        }

    public render() {
        const { dashboards, dashboardsLoaded } = this.props;
        const {
            noMatchingNames,
            matchedNameExact,
            name,
            filteredDashboards, userFavorites
        } = this.state;
        return (
            <React.Fragment>
                <h1 style={{ backgroundColor: "white" }}>Dashboards:</h1>
                {!dashboardsLoaded && <DataLoading dataTitle="Dashboards" />}
                {dashboardsLoaded && (
                    <React.Fragment>
                        <Card Style="width: 48rem; border-radius: 20% center">
                            <CardTitle tag="span">
                                <Input
                                    type="text"
                                    name="name"
                                    id="name"
                                    placeholder="Search Dashboard"
                                    onChange={this.handleInputChange}
                                    valid={matchedNameExact}
                                    invalid={noMatchingNames}
                                />
                                <FormFeedback valid={true}>
                                    {matchedNameExact && (
                                        <span>
                                            Dashboard found! Select to edit
                                            {name}
                                        </span>
                                    )}
                                </FormFeedback>
                                <FormFeedback invalid="true">
                                    {noMatchingNames && (
                                        <span>No dashboards match name entered </span>
                                    )}
                                </FormFeedback>
                            </CardTitle>
                            <CardBody>
                                {dashboards.length > 0 &&
                                    filteredDashboards.map((dashboard: IPbiDashboard) => (
                                        <div key={dashboard.id}>
                                            <span className="mr-2" onClick={() => this.toggleFavorite(dashboard.id)}>
                                                {
                                                    userFavorites.find(fav => fav.reportId === dashboard.id) ?
                                                        <FavoritesIcon />
                                                        :
                                                        <NotFavoritesIcon />
                                                }
                                            </span>

                                            <Link to={paths.pbiDashboards.concat(dashboard.id.toString())}>
                                                {dashboard.displayName}
                                            </Link>
                                        </div>



                                    ))}
                            </CardBody>
                        </Card>

                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IStore) => {

    return {
        accessToken: state.auth0.accessToken,
        dashboards: state.userDashboards,
        dashboardsLoaded: state.loadingDashboards,
        userFavoritesDashboards: state.userFavorites.length > 0 ? state.userFavorites.filter(fav => fav.reportType === "DASHBOARD") : state.userFavorites,
        userId: state.userProfile.id,
        activeRoleId: state.activeRoleId,
       // userFavorites: state.userFavorites.filter(fav => fav.reportType === "DASHBOARD")
    };
};

const mapDispatchToProps = (dispatch: any) => ({

    onHandleLoadDashboards: (accessToken: string) => {
        dispatch(handleLoadDashboards(accessToken));
    },

    onHandleAddFavorite: (accessToken: string, newFav: IUserFavorite) => {             
            dispatch(handleAddFavorite(accessToken, newFav));
        },
     
    onHandleDeleteFavorite: (accessToken: string, id: number) => {
        dispatch(handleDeleteFavorite(accessToken, id));
    },

 
                
});






export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListUserDashboardsPage);
